export const SERVER = 'https://instagramserver23.onrender.com'